import React, { useRef } from "react";
import { Mesh, MeshStandardMaterialParameters } from "three";
import { useLoader } from "@react-three/fiber";
import { STLLoader } from "three/examples/jsm/loaders/STLLoader";

import machineSTL from "./../assets/model_machine.stl";

import { TextureLoader, MeshStandardMaterial } from "three";

// Loads the Mahine
const CustomRaw = () => {
  const stlRef = useRef<Mesh | null>(null);

  const res = useLoader(STLLoader, machineSTL);

  const materialProps: MeshStandardMaterialParameters = {
    color: "silver", // Change color to silver or other metallic color
    metalness: 1,
    roughness: 0.1, // Decrease roughness for a smoother surface
    emissive: "black", // No emissive for a solid metal look
    emissiveIntensity: 0, // No emissive intensity
  };

  const baseColorTexture = new TextureLoader().load(
    "./../../assets/base-color.jpg"
  );

  const metallicMapTexture = new TextureLoader().load(
    "./../../assets/metallic-texture.jpg"
  );

  const metallicMaterial = new MeshStandardMaterial({
    metalnessMap: metallicMapTexture,
    roughness: 0.01,
  });

  const nonMetallicMaterial = new MeshStandardMaterial({
    map: baseColorTexture,
    metalness: 0,
  });

  return (
    <mesh
      receiveShadow
      ref={stlRef}
      scale={[0.08, 0.08, 0.08]}
      position={[-26, -8, -35]}
      rotation={[0, 3.12, 0]}
      material={metallicMaterial}
    >
      <primitive object={res} />
      <meshStandardMaterial />
    </mesh>
  );
};

export default CustomRaw;
